module.exports = __webpack_public_path__ + "static/media/img93.fb121a57.jpg";